import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from 'shared/pipes/pipes.module';

import { StatusSideNavComponent } from './status-sidenav/status-sidenav.component';
import { StatusSideNavV2Component } from './status-sidenav-v2/status-sidenav-v2.component';


@NgModule({
  imports: [
    CommonModule,
    PipesModule,
  ],
  declarations: [
    StatusSideNavComponent,
    StatusSideNavV2Component,
  ],
  exports: [
    StatusSideNavComponent,
    StatusSideNavV2Component,
  ],
  providers: []
})
export class StatusSideNavModule {}
